import { AddMedicDto } from "./addMedicDto";
import { EditMedicDto } from "./editMedicDto";
import { MedicDetailsDto } from "./medicDetailsDto";
import { Gender } from "../enums/gender";

export interface EditMedicFormDto {
  id?: number;
  userId?: number;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  phoneNumber: string;
  snils?: string;
  gender: Gender | '';
  isDismissed: boolean;
  companyIds: number[];
  photoFile?: File;
  photoUrl?: string;
  isTelemed?: boolean;
  esiaId?: string;
}

export const emptyEditMedicFormDto = (companyId?: number): EditMedicFormDto => {
  return {
    firstName: '',
    lastName: '',
    middleName: '',
    email: '',
    phoneNumber: '',
    gender: '',
    isDismissed: false,
    companyIds: companyId ? [companyId] : [],
    photoFile: undefined,
    photoUrl: undefined,
    isTelemed: false,
  }
};

export const mapToAddMedicDto = (formData: EditMedicFormDto): AddMedicDto => {
  return {
    firstName: formData.firstName,
    lastName: formData.lastName,
    middleName: formData.middleName,
    email: formData.email!,
    phoneNumber: formData.phoneNumber,
    gender: formData.gender,
    snils: formData.snils,
    companyIds: formData.companyIds,
    photoFile: formData.photoFile,
    isTelemed: formData.isTelemed,
  }
};

export const mapToEditMedicDto = (formData: EditMedicFormDto): EditMedicDto => {
  return {
    id: formData.id!,
    userId: formData.userId!,
    firstName: formData.firstName,
    lastName: formData.lastName,
    middleName: formData.middleName,
    email: formData.email!,
    phoneNumber: formData.phoneNumber,
    gender: formData.gender,
    snils: formData.snils,
    isDismissed: formData.isDismissed,
    companyIds: formData.companyIds,
    photoFile: formData.photoFile,
    photoUrl: formData.photoUrl,
    isTelemed: formData.isTelemed,
    esiaId: formData.esiaId,
  }
};

export const mapToEditMedicFormDto = (dto: MedicDetailsDto): EditMedicFormDto => {
  return {
    id: dto.id,
    userId: dto.userId,
    firstName: dto.firstName,
    lastName: dto.lastName,
    middleName: dto.middleName,
    email: dto.email!,
    phoneNumber: dto.phoneNumber,
    gender: dto.gender,
    snils: dto.snils,
    isDismissed: dto.isDismissed,
    companyIds: dto.companies ? dto.companies.map(c => c.id) : [],
    photoUrl: dto.photoUrl,
    isTelemed: dto.isTelemed,
    esiaId: dto.esiaId,
  }
};
